import { Brand } from 'constants/brand';
import { api } from 'api';

export const HAS_SUB_IB_API_CALL_CONFIG = {
  [Brand.FM]: (userId, dataRange) => api.getUserTradesCount(userId, dataRange),
  [Brand.GP]: (userId, dataRange) => api.getUserTradesCount(userId, dataRange),
  [Brand.DAY1]: (userId, dataRange) => api.getUserFeesCount(userId, dataRange),
};
